import React, { Component } from 'react';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Button from 'react-bootstrap-button-loader';
import Confirm from 'react-confirm-bootstrap';
import { Admin as Layout } from '../../../components/layouts';
import { Spinner } from '../../../components/common';
import { AdminApi } from '../../../api';
import { findComparator } from '../../../utils/helpers/filter_conversions';
import { humanize } from '../../../utils/helpers/text_formatters';
import EditFeedCampaignFormModal from '../../../components/admin/campaigns/feed/EditFeedCampaignForm';
import NewFeedCampaignFormModal from '../../../components/admin/campaigns/feed/NewFeedCampaignForm';
import StandardCampaignFormModal from '../../../components/admin/campaigns/standard/StandardCampaignForm';
import ShowModal from '../../../components/admin/common/Show';
import ExportCSVButton from '../../../components/common/ExportCSVButton';
import { ButtonShow, ButtonEdit, ButtonDelete } from '../../../components/common/buttons/actions';
import { handleOnFilterChange, handleOnSortChange, handleOnPageChange } from '../../../utils/helpers/admin/query_updating';
import { columnWidth, formatData } from '../../../utils/helpers/admin/table_formatters';

class AdminCampaignsIndex extends Component {
  componentWillMount() {
    this.fetchResource();
  }

  generateFilter(dataField) {
    const attributes = this.props?.resource?.meta?.column_info?.attributes || {};
    const dropdownColumns = ['type', 'status', 'internal_status'];
    const { value, predicate } = this.props?.resource?.meta?.filters?.[dataField] || {};
    const dropDownOptions = {
      status: {
        paused: 'paused',
        active: 'active',
        removed: 'removed',
      },
      internal_status: {
        pending: 'pending',
        suspended: 'suspended',
        opened: 'opened',
        ended: 'ended',
      },
      type: {
        FeedCampaign: 'FeedCampaign',
        SelfServeCampaign: 'SelfServeCampaign',
      },
    };
    let filter = {};

    switch (attributes[dataField]) {
      case 'identifier': {
        filter.type = 'TextFilter';
        filter.condition = 'eq';
        filter.defaultValue = '';
        if (value && predicate) filter.defaultValue = value;
        break;
      }
      case 'inet':
      case 'string': {
        filter.type = dropdownColumns.includes(dataField) ? 'SelectFilter' : 'TextFilter';
        filter.condition = 'like';
        filter.defaultValue = '';
        filter.options = dropDownOptions[dataField] ? dropDownOptions[dataField] : null;
        break;
      }
      case 'decimal':
      case 'integer': {
        filter.type = 'NumberFilter';
        filter.numberComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = {
            number: parseInt(value, 10),
            comparator: findComparator(predicate),
          };
        }
        break;
      }
      case 'boolean': {
        filter.type = 'SelectFilter';
        filter.options = {
          true: true,
          false: false,
        };
        break;
      }
      case 'datetime': {
        filter.type = 'DateFilter';
        filter.dateComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = {
            date: value,
            comparator: findComparator(predicate),
          };
        }
        break;
      }
      default:
        filter = {};
    }

    return filter;
  }

  newStandardResource() {
    const {
      resourceName,
      dispatch,
      resource: {
        meta: { column_info },
      },
    } = this.props;

    dispatch(
      show('AdminStandardCampaignModal', {
        attributes: column_info.attributes,
        formFields: column_info.new_form,
        resourceName,
        heading: 'New Standard Campaign',
        formAction: 'Create',
        metaParams: {},
      }),
    );
  }

  newFeedResource() {
    const {
      resourceName,
      dispatch,
      resource: {
        meta: { column_info },
      },
    } = this.props;

    dispatch(
      show('AdminNewFeedCampaignModal', {
        attributes: column_info.attributes,
        formFields: column_info.new_form,
        resourceName,
        heading: 'New Feed Campaign',
        formAction: 'Create',
        metaParams: {},
      }),
    );
  }

  handleShow(_c, resource) {
    const { resourceName, dispatch } = this.props;

    dispatch(
      show('AdminResourceShow', {
        resource,
        resourceName,
        heading: `${humanize(resourceName)} Details`,
        onEdit: this.handleEdit.bind(this),
        showButtons: true,
      }),
    );
  }

  handleDelete(r, callback = null) {
    const { dispatch } = this.props;
    const campaignType = r.type === 'FeedCampaign' ? 'feedCampaign' : 'selfServeCampaign';

    dispatch(
      AdminApi.actions[`${campaignType}Delete`].post(r.id, (_error, success) => {
        if (success) {
          this.fetchResource({
            page: this.props?.resource?.meta?.pagination?.page || 1,
            per_page: this.props?.resource?.meta?.pagination?.per_page || 10,
            filters: this.props?.resource?.meta?.filters || {},
            sort: this.props?.resource?.meta?.sort || {},
          });
          if (callback) callback();
        }
      }),
    );
  }

  handleEdit(_c, r) {
    const {
      resourceName,
      dispatch,
      resource,
      resource: {
        meta: { column_info },
      },
    } = this.props;
    const metaParams = {
      page: this.props?.resource?.meta?.pagination?.page || 1,
      per_page: this.props?.resource?.meta?.pagination?.per_page || 10,
      filters: this.props?.resource?.meta?.filters || {},
      sort: this.props?.resource?.meta?.sort || {},
    };

    if (r.type === 'FeedCampaign') {
      const template =
        resource.templates.find(t => {
          return t.feed_campaign_id === r.id;
        }) || {};
      dispatch(
        show('AdminFeedCampaignModal', {
          attributes: column_info.attributes,
          formFields: column_info.new_form,
          resourceName,
          resource: r,
          template,
          heading: 'Editing Feed Campaign',
          formAction: 'Update',
          metaParams,
          onShow: this.handleShow.bind(this),
        }),
      );
    } else {
      dispatch(
        show('AdminStandardCampaignModal', {
          attributes: column_info.attributes,
          formFields: column_info.edit_form,
          resourceName,
          resource: r,
          heading: 'Editing Standard Campaign',
          formAction: 'Update',
          metaParams,
          onShow: this.handleShow.bind(this),
        }),
      );
    }
  }

  fetchResource(params = {}) {
    const { resourceName, dispatch } = this.props;

    dispatch(AdminApi.actions[resourceName](params));
    dispatch(AdminApi.actions.feedTemplate());
    dispatch(AdminApi.actions.account({ per_page: 2000 }));
  }

  renderActions(c, r) {
    const { resourceName } = this.props;
    const renderDelete = r.status !== 'removed';

    return (
      <ul className="list-inline">
        <li>
          <ButtonShow className="btn-trans" bsStyle="primary" onClick={this.handleShow.bind(this, c, r)} />
        </li>
        <li>
          <ButtonEdit className="btn-trans" bsStyle="primary" onClick={this.handleEdit.bind(this, c, r)} />
        </li>
        {renderDelete && (
          <li title="Delete" rel="tooltip" className="">
            <Confirm
              onConfirm={this.handleDelete.bind(this, r)}
              body={`Are you sure you want to delete the campaign ${r.name}?`}
              confirmText="Confirm Delete"
              title={`Deleting ${humanize(resourceName)}`}
            >
              <div>
                <ButtonDelete className="btn-trans" bsStyle="primary" />
              </div>
            </Confirm>
          </li>
        )}
      </ul>
    );
  }

  render() {
    const { resourceName, resource, isLoading, fetchParams, columnAttributes } = this.props;
    const { data, meta } = resource || {};
    const { filters } = meta || {};
    const { pagination, column_info, sort } = meta || {};
    const index = column_info?.index_page || [];
    if (index.length > 1) index.move(index.indexOf('referencenumber'), 0);

    const CSVButton = () => {
      return <ExportCSVButton resourceName={resourceName} filters={filters} sort={sort} />;
    };

    const options = {
      exportCSVBtn: CSVButton,
      onFilterChange: handleOnFilterChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      onSortChange: handleOnSortChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sortName: sort?.field || 'id',
      sortOrder: sort?.order || 'desc',
      defaultSortName: sort?.field || 'id',
      defaultSortOrder: sort?.order || 'desc',
      sizePerPage: pagination?.per_page || 10,
      onPageChange: handleOnPageChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: pagination?.current_page || 1,
    };
    const fetchInfo = {
      dataTotalSize: pagination?.total_count || 0,
    };
    const selectRow = {
      mode: 'checkbox',
    };
    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);

    return (
      <Layout {...passProps}>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{humanize(resourceName)}</h5>
          </div>
          <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            <div className="pull-right">
              <Button bsSize="small" onClick={this.newStandardResource.bind(this)} bsStyle="info" className="m-l-xs">
                Add Standard
              </Button>
              <Button bsSize="small" onClick={this.newFeedResource.bind(this)} bsStyle="info" className="m-l-xs">
                Add Feed
              </Button>
            </div>
            <div>
              <BootstrapTable
                exportCSV
                striped
                ref={'CampaignTable'}
                data={data || []}
                remote
                pagination
                fetchInfo={fetchInfo}
                selectRow={selectRow}
                options={options}
              >
                {index.length > 1 ? (
                  index.map((field, i) => {
                    const isResourceKey = field === 'referencenumber';

                    return (
                      <TableHeaderColumn
                        key={`${resourceName}-column-${i}`}
                        isKey={isResourceKey}
                        width={columnWidth(field, columnAttributes)}
                        dataSort={!isResourceKey}
                        dataField={field}
                        filter={isResourceKey ? {} : this.generateFilter(field)}
                        dataFormat={isResourceKey ? this.renderActions.bind(this) : formatData.bind(this, field, columnAttributes)}
                        tdStyle={{ whiteSpace: 'normal' }}
                        thStyle={{ whiteSpace: 'normal' }}
                      >
                        {isResourceKey ? 'Actions' : field}
                      </TableHeaderColumn>
                    );
                  })
                ) : (
                  <TableHeaderColumn isKey dataField={resourceName} />
                )}
              </BootstrapTable>
              <EditFeedCampaignFormModal />
              <NewFeedCampaignFormModal />
              <StandardCampaignFormModal />
              <ShowModal />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const resourceName = 'campaign';
  let resource = state.admin[resourceName];
  resource = { ...resource, data: { ...resource.data, templates: state.admin.feedTemplate.data.data || [] } };
  const columnAttributes = resource?.data?.meta?.column_info?.attributes || {};
  const fetchParams = {
    page: resource?.data?.meta?.pagination?.page || 1,
    per_page: resource?.data?.meta?.pagination?.per_page || 10,
    filters: resource?.data?.meta?.filters || {},
    sort: resource?.data?.meta?.sort || {},
  };

  return {
    resourceName,
    resource: resource.data,
    isLoading: resource.loading,
    fetchParams,
    columnAttributes,
  };
};
export default connect(mapStateToProps)(AdminCampaignsIndex);
